export default __webpack_public_path__ + "static/media/soundfound_logo.edbbcc7e.gif";